import styled, { css } from 'styled-components';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: var(--main-font-family);
  font-weight: normal;
  font-style: normal;
  width: 100%;
  position: relative;
  cursor: pointer;
  min-width: 80px;

  ${(p) =>
    p.disabled &&
    css`
      cursor: not-allowed;
      border-width: 0;
      background-color: var(--color-grey-1);
    `}

  .react-datepicker-wrapper {
    width: 100%;
    height: 100%;
  }

  .react-datepicker {
    border: none;
    box-shadow: 0px 2px 8px 0px rgba(19, 20, 22, 0.12);
    border-radius: 12px;
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__month-container {
    padding: 8px;
  }

  .react-datepicker-popper {
    left: -1px;
    z-index: 999999;
  }

  .react-datepicker-popper[data-placement^='bottom'] {
    margin-top: 0;

    .react-datepicker__triangle {
      display: none;
    }
  }

  .react-datepicker__navigation {
    top: 18px;
  }

  .react-datepicker__header {
    background-color: var(--color-white);
    border-width: 0;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    font-family: var(--main-font-family);
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 14px;
  }

  .react-datepicker__current-month {
    margin-top: 3px;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    font: var(--font-regular-15);
    color: #000;
    width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 2px 1px;
  }

  .react-datepicker__day--outside-month {
    color: rgba(12, 18, 28, 0.3);
  }

  .react-datepicker__day,
  .react-datepicker__day--keyboard-selected {
    font: var(--font-regular-15);
    padding: 9px 7px;
    margin: 2px 1px;
    width: 40px;
    height: 40px;
    background-color: var(--color-white);
    line-height: 22px;
    border-radius: 12px;
  }

  .react-datepicker__day:hover,
  .react-datepicker__day--keyboard-selected:hover {
    background: rgba(73, 84, 104, 0.1);
  }

  .react-datepicker__day--today {
    position: relative;

    &:after {
      display: block;
      content: ' ';
      background: rgba(230, 0, 0, 1);
      width: 4px;
      height: 4px;
      border-radius: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .react-datepicker__day--selected {
    //border-radius: 0;
    background: rgba(73, 84, 104, 0.1);
    //background-color: var(--color-blue-4);
    color: var(--color-black);
  }

  .react-datepicker__day--selected:hover {
    //background-color: var(--color-blue-4);
    background: rgba(73, 84, 104, 0.1);
  }

  .react-datepicker__day--disabled {
    color: rgba(12, 18, 28, 0.3);
    cursor: default;
    background-color: white;
  }

  .react-datepicker__day--disabled:hover {
    background-color: white;
  }
`;

export const DatePickerStyled = styled(DatePicker)`
  user-select: none;
  border-width: 0;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  box-sizing: border-box;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  background-color: ${(p) => (p.disabled ? 'transparent' : 'transparent')};

  &:focus {
    outline: 0;
    box-shadow: none;
  }

  ${(p) =>
    p.label &&
    css`
      top: 20px;
      height: 20px;
    `}
`;
